// @flow

import * as Immutable from 'immutable';
import { createSelector } from 'reselect';

import type { State, Action, Dispatch, GetState } from '../../lib/types';
import * as alerts from '../alerts';
import request from 'superagent';

export const ALTERA_URL  = 'nfe/classificacaoFiscal/ALTERA_URL',
             CARREGA_LISTA_CLASSIFICACAO = 'nfe/classificacaoFiscal/CARREGA_LISTA_CLASSIFICACAO',
             LISTA_CLASSIFICACAO_OK = 'nfe/classificacaoFiscal/LISTA_CLASSIFICACAO_OK',
             LISTA_CLASSIFICACAO_ERRO = 'nfe/classificacaoFiscal/LISTA_CLASSIFICACAO_ERRO';

const DEFAULT_STATE = Immutable.fromJS({ url: '', observacoesClassificacao: '', opcaoClassificacao: '',
  listaClassificacao: [], carregandoLista: false });

export default function reducer(state : Immutable.Map = DEFAULT_STATE, action : Action) {
  switch (action.type) {
    case ALTERA_URL:
      return state.set('url', action.url);
    case CARREGA_LISTA_CLASSIFICACAO:
      return state.set('carregandoLista', true);
    case LISTA_CLASSIFICACAO_OK:
      return state.set('carregandoLista', false).set('listaClassificacao', Immutable.fromJS(action.items));
    case LISTA_CLASSIFICACAO_ERRO:
      return state.set('carregandoLista', false).set('listaClassificacao', Immutable.List());
    default:
      return state;
  }
}

// selectors

export const rootSelector = (state : State) => state.getIn(['nfe', 'classificacaoFiscal'], DEFAULT_STATE);
export const urlSelector = createSelector<*, *, *, *>(rootSelector, root => root.get('url',  ''));
export const listaClassificacaoSelector = createSelector<*, *, *, *>(rootSelector, root =>
    root.get('listaClassificacao',  []).map(m => (
        { value: m.get('value'), label: m.get('label') }
    )).toArray());

// action creators

export function alteraUrl(url : string) {
  return { type: ALTERA_URL, url };
}

/**
* Carrega a lista de classificação, se necessário.
*/
export function carregaListaClassificacao() {
  return async function(dispatch : Dispatch<*>, getState : GetState) {
    const lista = listaClassificacaoSelector(getState());
    if (lista.size > 0)
      return;

    await dispatch({ type: CARREGA_LISTA_CLASSIFICACAO });

    try {
      const r = await request.get('/app/nfe/lista_classificacao');
      await dispatch({ type: LISTA_CLASSIFICACAO_OK, items: r.body.lista });
    }
    catch (e) {
      await dispatch(alerts.alert('danger', 'Erro ao carregar lista de municípios.'));
      await dispatch({ type: LISTA_CLASSIFICACAO_ERRO  });
    }
  };
}